import React from "react";
import { DocumentsList } from "../../components/cpm/DocumentsList";
import { CoRetrieveDocumentData } from "../../components/generic/CoRetrieveDocumentData";
import { UserFunctionEnum } from "../../api/models/user-function-enum";
import { UnauthorizedError } from "../../components/generic/UnauthorizedError";
import { ProtectedComponent } from "../../components/wrappers/ProtectedComponent";

export const DocumentListPage: React.FunctionComponent = () => {
  return (
    <ProtectedComponent userFunction={UserFunctionEnum.MENU_DOCUMENT_LIBRARY} errorComponent={<UnauthorizedError />}>
      <CoRetrieveDocumentData>
        {({ coObject }) =>
          coObject?.documentId ? <DocumentsList idPartRoot={coObject.documentId} /> : <DocumentsList />
        }
      </CoRetrieveDocumentData>
    </ProtectedComponent>
  );
};
